import { baseUrl } from "@/util/api/baseUrl";
import { ConvertLink } from "@/util/tools";
import { ScrollText } from "lucide-react";
import Link from "next/link";
import { useCallback, useEffect, useState } from "react";

const categories = ["نقد و بررسی", "برترین ها", "تاریخچه", "دانستنی ها", "اخبار"];

async function fetchBlogs() {
  const fetcher = async (url: string) => {
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`Error fetching ${url}`);
      return await res.json();
    } catch (error) {
      console.error(error);
      return { data: { rows: [] } }; // مقدار پیش‌فرض برای جلوگیری از خطا
    }
  };
  const blogData = await Promise.all(
    categories.map((category) =>
      fetcher(
        `${baseUrl}/article-list?size=6&page=1&cat=${encodeURIComponent(category)}`
      )
    )
  );
  return blogData;
}
const MenuBlog = () => {

  const [listBlog, setListBlog] = useState<any>()
  const getData = useCallback(async () => {
    const data = await fetchBlogs();
    setListBlog(data)
  }, [])
  useEffect(() => {
    if (!listBlog) {
      getData()
    }
  }, [listBlog])
  return (
    <div className="absolute container top-10 left-1/2 transform -translate-x-1/2 invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-opacity duration-300">
      <div className="flex flex-wrap w-full py-5 px-10 bg-main">
        {listBlog?.length > 0 && listBlog.map((item: any, idx: number) => {
          const blog = item.data?.rows;
          return (
            <div key={idx} className="w-1/2 p-2">
              <div className="bg-white rounded-md">
                {blog[0] && (
                  <Link
                    className="inline font-bold border-b-2  hover:text-pink border-patch my-2 text-text text-lg"
                    href={`/blog/${ConvertLink(blog[0].Category.cat_url)}`}
                  >
                    {blog[0].Category.cat_title}
                  </Link>
                )}
                {blog.map((child: any) => (
                  <Link
                    className="flex items-center text-sm my-2 hover:text-pink hover:mr-1 transition-all duration-300 hover:font-bold opacity-80"
                    key={child.id}
                    href={`/mag/${ConvertLink(child.article_url)}`}
                  >
                    <ScrollText className="size-4 ml-1" />{" "}
                    <span className="truncate">{child.article_title}</span>
                  </Link>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MenuBlog;